package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomCharacteristicRule
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomCharacteristicStatus
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class SyndromeIndicationSignSymptomCharacteristic(var id: String? = null){
	var syndromeIndicationSignSymptomId: String? = null
	var signSymptomCharacteristicId: String? = null
	var rule: SyndromeIndicationSignSymptomCharacteristicRule? = null
	var status: SyndromeIndicationSignSymptomCharacteristicStatus? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null
	var weight: Int? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SyndromeIndicationSignSymptomCharacteristic
		if (id != other.id) return false
		if (syndromeIndicationSignSymptomId != other.syndromeIndicationSignSymptomId) return false
		if (signSymptomCharacteristicId != other.signSymptomCharacteristicId) return false
		if (rule != other.rule) return false
		if (status != other.status) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		if (weight != other.weight) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (syndromeIndicationSignSymptomId?.hashCode() ?: 0)
		result = 31 * result + (signSymptomCharacteristicId?.hashCode() ?: 0)
		result = 31 * result + (rule?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		return result
	}

}
